/**
 * Adjusts the scroll position and bottom padding of a container on mobile devices
 * to ensure a trigger element is visible above the on-screen keyboard.
 *
 * @param {Ref<boolean>} mobile - The mobile ref from useDisplay().
 * @param {HTMLElement} triggerEl - The element to scroll into view.
 * @param {string} containerSelector - CSS selector for the scrollable container.
 * @param {boolean} [addPadding=true] - Whether to add extra bottom padding for keyboard space.
 */
const adjustMobileScroll = (mobile, triggerEl, containerSelector, addPadding = true) => {
  if (!mobile.value) return

  setTimeout(() => {
    const container = document.querySelector(containerSelector)
    if (container) {
      if (addPadding) {
        const viewportHeight = window.innerHeight
        const keyboardSpace = Math.round(Math.max(viewportHeight * 0.5, 300))
        container.style.paddingBottom = `${keyboardSpace}px`

        const containerRect = container.getBoundingClientRect()
        const triggerRect = triggerEl.getBoundingClientRect()
        const relativeTop = triggerRect.top - containerRect.top
        const targetScrollTop = container.scrollTop + relativeTop - 200

        container.scrollTo({
          top: targetScrollTop,
          behavior: 'smooth',
        })
      } else {
        container.style.paddingBottom = '0'
      }
    }
  }, 100)
}

export { adjustMobileScroll }
